'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dU$002dU$002dI$002dD from "./java.util.-U-U-I-D.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$$anon$6$$anon$16(evaluator$13) {
  this.Lf = null;
  this.Lf = evaluator$13;
}
export { $c_Lsamples_EnumSample$package$$anon$6$$anon$16 as $c_Lsamples_EnumSample$package$$anon$6$$anon$16 };
$p = $c_Lsamples_EnumSample$package$$anon$6$$anon$16.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EnumSample$package$$anon$6$$anon$16;
/** @constructor */
function $h_Lsamples_EnumSample$package$$anon$6$$anon$16() {
}
export { $h_Lsamples_EnumSample$package$$anon$6$$anon$16 as $h_Lsamples_EnumSample$package$$anon$6$$anon$16 };
$h_Lsamples_EnumSample$package$$anon$6$$anon$16.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lf.h();
  return ((v instanceof $j_java$002eutil$002e$002dU$002dU$002dI$002dD.$c_ju_UUID) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_EnumSample$package$$anon$6$$anon$16 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$$anon$6$$anon$16, "samples.EnumSample$package$$anon$6$$anon$16", ({
  p2: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EnumSample$package$$anon$6$$anon$16 as $d_Lsamples_EnumSample$package$$anon$6$$anon$16 };
